import { Personnel } from "./personnel";


 export class Users {
    id: number;
    firstName: string;
    lastName: string;
    emailAddress: string;
    username: string;
    isActive: boolean;
    isSuperAdmin: boolean;
    ceService: string;
    name: string;
    titre: string;
    personnel: Personnel;
    permissions: [string];
    password?: string;

    public toString(): string {
      return `${this.firstName} ${this.lastName}`;
    }
  }



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/models/users.ts